import Service from '@/features/data/dataService.js'

const REFRESH_INTERVAL = 60000 // 1 minute

let refreshInterval = null

export function startGlobalDataRefresh() {
  if (refreshInterval) return // Déjà démarré

  // Premier appel immédiat
  refreshGlobalData()

  // Puis périodiquement
  refreshInterval = setInterval(() => {
    refreshGlobalData()
  }, REFRESH_INTERVAL)
}

async function refreshGlobalData() {
  try {
    await Service.getSingleData('globalData', {})
    console.log('🔄 Global data refreshed', window.__RAPIDOO_GLOBAL_DATA__?.lastUpdate)
  } catch (error) {
    console.error('Failed to refresh global data:', error)
  }
}

export function stopGlobalDataRefresh() {
  if (refreshInterval) {
    clearInterval(refreshInterval)
    refreshInterval = null
  }
}

export function getGlobalData() {
  return typeof window !== 'undefined' ? window.__RAPIDOO_GLOBAL_DATA__ : null
}
